import { render } from "./CustomerRepresentativeEdit.vue?vue&type=template&id=1d559d22"
import script from "./CustomerRepresentativeEdit.vue?vue&type=script&lang=js"
export * from "./CustomerRepresentativeEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__